import { genreList } from "@/mocks/manhwa";

export default function Genres() {
  const goRank = (name: string) => {
    const el = document.getElementById("ranking");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="genres" className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm font-medium text-secondary-800">
            <i className="ri-grid-fill"></i> 按类型逛
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black text-foreground-900 md:text-4xl">漫画分类推荐</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            不知道自己想追什么？先从喜欢的类型入手，六大热门分类让你轻松找到对味的那一部。
          </p>
        </div>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {genreList.map((genre) => (
          <button
            key={genre.name}
            type="button"
            onClick={() => goRank(genre.name)}
            className="group relative overflow-hidden rounded-2xl text-left"
          >
            <img
              src={genre.cover}
              alt={`${genre.name} 好看的韩国漫画分类`}
              className="aspect-[3/2] w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg font-bold text-white">{genre.name}</h3>
                <span className="rounded-full bg-white/20 px-2.5 py-0.5 text-xs font-medium text-white backdrop-blur-sm">
                  {genre.count}
                </span>
              </div>
              <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-white/80 md:text-sm">{genre.desc}</p>
              <span className="mt-2 inline-flex items-center gap-1 text-sm font-medium text-primary-200">
                查看推荐 <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}